import Box from '@mui/material/Box'
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import * as React from 'react'
import {
  masterPrivilegesApi,
  masterRolePostApi,
} from '../../../api/master/masterAPI'
import { useEffect } from 'react'
import { useFormik } from 'formik'
import jwt_decode from 'jwt-decode'
import LoadingSection from '../../../common/components/loaders/loader'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
  getCompanyLevel,
  normalizeApiResponse,
  requiredLabel,
} from '../../../helpers/HelperFunctions'
import { RoleFormValidation } from '../../../validations/UserManagementValidation'
import { useToastContext } from '../../../App'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import { COMPANY_LEVELS, SERVICE_MANAGEMENT_CREATE_SERVICE_ID } from '../../../helpers/Constants'

//--- states for add roles Management checkboxes --

const allManagements = []

export function AddNewRole(props) {
  const { dispatch, state: commonState } = useCommonRedux()
  const { toast } = useToastContext()
  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [permissionList, setPermissionList] = React.useState([])
  const [allManagement, setAllManagement] = React.useState(allManagements)
  const [serviceErrorMessage, setServiceErrorMessage] = React.useState(null)
  const [searchParams] = useSearchParams()
  const location = useLocation()

  const getPrivilegesApi = () => {
    masterPrivilegesApi(
      getCompanyLevel(
        searchParams.get('company_id'),
        location.pathname.slice(1)
      )
    ).then((response) => {
      let billingFilter
      if (location.pathname.slice(1) == 'master') {
        billingFilter = response.data.result
      } else if (
        location.pathname.slice(1) == 'serviceprovider' &&
        !commonState.currentCompanyDetails?.isAltigenBilling
      ) {
        billingFilter = response.data.result.filter(
          (datFilt) => datFilt.groupName !== 'Billing'
        )
      } else if (
        location.pathname.slice(1) == 'serviceprovider' &&
        commonState.currentCompanyDetails?.isAltigenBilling
      ) {
        billingFilter = response.data.result.filter(
          (datFilt) =>
            datFilt.groupName !== 'Reseller Billing' &&
            datFilt.groupName !== 'Customer Billing'
        )
      } else if (
        location.pathname.slice(1) == 'reseller' &&
        commonState.currentCompanyDetails?.isAltigenBilling
      ) {
        billingFilter = response.data.result.filter(
          (datFilt) => datFilt.groupName !== 'Customer Billing'
        )
      } else if (
        location.pathname.slice(1) == 'reseller' &&
        !commonState.currentCompanyDetails?.isAltigenBilling &&
        commonState.currentCompanyDetails?.isRevParent
      ) {
        billingFilter = response.data.result.filter(
          (datFilt) => datFilt.groupName !== 'Billing'
        )
      } else if (
        location.pathname.slice(1) == 'customer' &&
        commonState.currentCompanyDetails?.isAltigenBilling
      ) {
        billingFilter = response.data.result
      } else {
        billingFilter = response.data.result.filter(
          (datFilt) => !datFilt.groupName.includes('Billing')
        )
      }
      setPermissionList(billingFilter)
      billingFilter.forEach((dat) => {
        allManagements.push(true)
      })
    })
  }

  const toggleRelatedViewPrivileges = (privileges, displayName, isChecked) => {
    if (/(update|create|delete)/.test(displayName) && isChecked) {
      privileges.forEach((item) => {
        if (item.displayName.toLowerCase().includes("view")) {
          item.isAssigned = true;
        }
      });
    }
  };

  const unassignDependentPrivileges = (privileges, displayName, isChecked, index1, setAllManagement) => {
    if (displayName.includes("view") && !isChecked) {
      privileges.forEach((item) => {
        const name = item.displayName.toLowerCase();
        if (/(update|create|delete)/.test(name)) {
          item.isAssigned = false;
        }
      });

      setAllManagement((prevState) => {
        if (privileges.length > 1) {
          prevState[index1] = false;
        }
        return [...prevState];
      });
    }
  };

  const assignCompanyViewPrivileges = (state, group) => {
    state.forEach((groupItem) => {
      if (groupItem.groupName == group) {
        groupItem.privileges.forEach((p) => {
          if (p.value.toLowerCase().includes("view")) {
            p.isAssigned = true;
          }
        });
      }
    });
  };

  const handleCompanyPrivilegeAssignment = (state, value) => {
    const valueLower = value.toLowerCase();
    if (valueLower.includes("serviceprovider"))
      assignCompanyViewPrivileges(state, "ServiceProvider Company");
    if (valueLower.includes("reseller"))
      assignCompanyViewPrivileges(state, "Reseller Company");
    if (valueLower.includes("customer"))
      assignCompanyViewPrivileges(state, "Customer Company");
  };

  const assignProductViewPrivileges = (state, keywords, targets) => {
    const lowerKeywords = keywords.map((k) => k.toLowerCase());

    const shouldAssign = (privValue) =>
      lowerKeywords.some((kw) => privValue.includes(kw)) &&
      targets.some((target) => privValue.includes(target));

    state.forEach((group) => {
      group.privileges.forEach((priv) => {
        const privValue = priv.value.toLowerCase();
        if (shouldAssign(privValue)) {
          priv.isAssigned = true;
        }
      });
    });
  };

  const handleProductPrivilegeAssignment = (state, value) => {
    const valueLower = value.toLowerCase();

    const productRules = [
      {
        keywords: ["customer.product.create", "customer.product.update"],
        targets: [
          "reseller.product.view",
          "serviceprovider.product.view",
          "master.product.view",
        ],
      },
      {
        keywords: ["reseller.product.create", "reseller.product.update"],
        targets: ["serviceprovider.product.view", "master.product.view"],
      },
      {
        keywords: ["serviceprovider.product.create", "serviceprovider.product.update"],
        targets: ["master.product.view"],
      },
    ];

    productRules.forEach(({ keywords, targets }) => {
      if (keywords.some((k) => valueLower.includes(k))) {
        assignProductViewPrivileges(state, keywords, targets);
      }
    });
  };

  const updateAllManagementState = (privileges, index1, isChecked, setAllManagement) => {
    const checkedCount = privileges.filter((o) => o.isAssigned).length;
    const total = privileges.length;

    const toggleAll =
      (checkedCount === total && isChecked) ||
      (checkedCount === total - 1 && !isChecked);

    if (toggleAll) {
      setAllManagement((prevState) =>
        prevState.map((item, i) => (i === index1 ? !item : item))
      );
    }
  };

  const handlePrivileges = (e, index1, index2) => {
    const isChecked = e.target.checked;

    setPermissionList((prev) => {
      const newState = [...prev];
      const privilege = newState[index1].privileges[index2];
      const displayName = privilege.displayName.toLowerCase();
      const value = privilege.value.toLowerCase();

      privilege.isAssigned = isChecked;

      // --- Delegate logic ---
      toggleRelatedViewPrivileges(newState[index1].privileges, displayName, isChecked);
      unassignDependentPrivileges(
        newState[index1].privileges,
        displayName,
        isChecked,
        index1,
        setAllManagement
      );

      handleCompanyPrivilegeAssignment(newState, value);
      handleProductPrivilegeAssignment(newState, value);
      updateAllManagementState(newState[index1].privileges, index1, isChecked, setAllManagement);

      return newState;
    });
  };

  const assignCompanyViews = (newState) => {
    const companies = [
      { key: "serviceprovider", label: "ServiceProvider Company" },
      { key: "reseller", label: "Reseller Company" },
      { key: "customer", label: "Customer" },
    ];

    companies.forEach(({ label }) => {
      assignCompanyViewPrivileges(newState, label);
    });
  };

  const assignProductViews = (newState) => {
    const rules = [
      {
        keywords: ["customer.product.create", "customer.product.update"],
        targets: [
          "reseller.product.view",
          "serviceprovider.product.view",
          "master.product.view",
        ],
      },
      {
        keywords: ["reseller.product.create", "reseller.product.update"],
        targets: [
          "serviceprovider.product.view",
          "master.product.view",
        ],
      },
      {
        keywords: ["serviceprovider.product.create", "serviceprovider.product.update"],
        targets: ["master.product.view"],
      },
    ];

    rules.forEach(({ keywords, targets }) =>
      assignProductViewPrivileges(newState, keywords, targets)
    );
  };
  const toggleAllPrivileges = (state, index, isChecked) => {
    state[index].privileges.forEach((obj) => {
      obj.isAssigned = isChecked;
    });

    setAllManagement((prevState) =>
      prevState.map((item, i) => (i === index ? !item : item))
    );

  };
  const handleAllPrivileges = (e, role, index) => {
    const isChecked = e.target.checked;
    const isNotEmptyRole = role != null && role != undefined && role.length !== 0;
    setPermissionList((prev) => {
      const newState = [...prev];

      if (isChecked) {
        assignCompanyViews(newState);
        assignProductViews(newState);
      } else if (isNotEmptyRole) {
        toggleAllPrivileges(newState, index, isChecked);
      }
      return newState;
    });
  };

  // Utility
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);


  const checkCompanyViewPermission = (permissions, companyType) => {
    if (!Array.isArray(permissions) || !companyType) return false;

    return permissions
      .filter((role) => role.groupName?.toLowerCase().includes('company'))
      .some((role) =>
        role.privileges?.some(
          (priv) =>
            priv.value?.toLowerCase().includes(companyType.toLowerCase()) &&
            priv.value?.toLowerCase().includes('view') &&
            priv.isAssigned
        )
      );
  };

  const checkServiceSelectedBool = (permissions) => {
    const rules = [
      {
        keywords: ['customer.product.create', 'customer.product.update'],
        target: 'reseller.product.view',
        errorMsg:
          'Please select View Service permission on Reseller Service Management',
      },
      {
        keywords: ['reseller.product.create', 'reseller.product.update'],
        target: 'serviceprovider.product.view',
        errorMsg:
          'Please select View Service permission on Serviceprovider Service Management',
      },
      {
        keywords: [
          'serviceprovider.product.create',
          'serviceprovider.product.update',
        ],
        target: 'master.product.view',
        errorMsg:
          'Please select View Service permission on Master Service Management',
      },
    ]

    const allPrivileges = permissions.flatMap((p) => p.privileges)
const isKeywordMatch = (priv, keywordList) =>
  keywordList.some((k) => priv.value.toLowerCase().includes(k));
const getAssignedPrivileges = (privList, keywordList) => {
  if (!Array.isArray(privList) || !Array.isArray(keywordList)) return [];
  return privList.filter((priv) => priv.isAssigned && isKeywordMatch(priv, keywordList));
};


    const findPrivilegeByTarget = (privList, target) =>
      privList.find((priv) => priv.value.toLowerCase().includes(target))

    for (const { keywords, target, errorMsg } of rules) {
      const assignedPrivileges = getAssignedPrivileges(allPrivileges, keywords)
      if (!assignedPrivileges.length) continue

      const targetPriv = findPrivilegeByTarget(allPrivileges, target)
      if (!targetPriv?.isAssigned) {
        toast.showToast(errorMsg, 'error')
        return false
      }
    }

    return true
  }
  useEffect(() => {
    getPrivilegesApi()
  }, [])

  const formik = useFormik({
    initialValues: {
      roleName: '',
      companyId: '',
      description: '',
      privileges: [],
      roleStatus: 1,
    },
    validationSchema: RoleFormValidation,
    onSubmit: async (data) => {
      const decodeToken = localStorage.getItem('sd_cp.jwt:tkn');
      const decoded = jwt_decode(decodeToken);

      const companyId = searchParams.get('company_id') || decoded?.company_id;
      data.companyId = companyId;

      // Helper functions to improve readability
      const hasAllCompanyViews = () =>
        checkCompanyViewPermission(permissionList, 'serviceprovider') &&
        checkCompanyViewPermission(permissionList, 'reseller') &&
        checkCompanyViewPermission(permissionList, 'customer');

      const hasSPAndResellerCustomer = () =>
        checkCompanyViewPermission(permissionList, 'reseller') &&
        checkCompanyViewPermission(permissionList, 'customer');

      const hasOnlyCustomerView = () =>
        checkCompanyViewPermission(permissionList, 'customer');

      const currentPath = location.pathname.slice(1);

      const flattenPrivileges = (list) => {
  const isAssignedPrivilege = (priv) => priv.isAssigned;
  const getPrivilegeId = (priv) => priv.id;

  const extractAssignedIds = (role) => {
    const assigned = role.privileges.filter(isAssignedPrivilege);
    return assigned.map(getPrivilegeId);
  };

  const allPrivileges = list.flatMap(extractAssignedIds);

  return allPrivileges.filter(Boolean);
};

      // Build privilege list
      const removeBlankArray = flattenPrivileges(permissionList);
      data.privileges = removeBlankArray;

      // Customer restriction logic
      const { currentCompanyDetails } = commonState;
      if (
        currentCompanyDetails?.companyLevel == COMPANY_LEVELS.customer &&
        !currentCompanyDetails.directCustomer
      ) {
        data.privileges = data.privileges.filter(
          (item) => item !== SERVICE_MANAGEMENT_CREATE_SERVICE_ID
        );
      }

      // Validation checks
      if (!removeBlankArray.length) {
        toast.showToast('Minimum one permission should be selected', 'error');
        return;
      }

      const pathConditions = [
        hasAllCompanyViews() &&
        ['master', 'serviceprovider'].includes(currentPath),
        hasSPAndResellerCustomer() && currentPath == 'reseller',
        hasOnlyCustomerView() && currentPath == 'customer',
      ];

      if (!pathConditions.some(Boolean)) {
        toast.showToast('Company View should be selected', 'error');
        return;
      }

      if (!checkServiceSelectedBool(permissionList)) {
        // toast.showToast(serviceErrorMessage, 'error');
        return;
      }

      try {
        setSubmitLoader(true);
        const response = await masterRolePostApi(
          data,
          getCompanyLevel(searchParams.get('company_id'), currentPath)
        );
        toast.showToast(response.data.message, 'success');
        props?.toggleDrawer('right', true);
        props.toggleDrawer('right', false, '', '', true);
      } catch (error) {
        toast.showToast(normalizeApiResponse(error)?.message, 'error');
      } finally {
        setSubmitLoader(false);
      }
    },
  });
  return <>
    {submitLoader ? <LoadingSection></LoadingSection> : ''}
    <Box role="presentation">
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          padding: '5px 10px 90px 20px',
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Grid container columnSpacing={4} rowSpacing={3}>
            <Grid item md={6} sm={6} xs={6}>
              {requiredLabel('Role Name')}
              <TextField
                id="roleName"
                name="roleName"
                onChange={formik.handleChange}
                value={formik.values.roleName}
                fullWidth
                InputProps={{
                  style: {
                    height: '35px',
                  },
                }}
              />
              <div
                style={{
                  color: 'red',
                  position: 'absolute',
                  marginBottom: '5px',
                }}
              >
                {formik.errors.roleName && formik.errors.roleName}
              </div>
            </Grid>
            <Grid
              item
              md={12}
              sm={12}
              xs={12}
              style={{ marginBottom: '10px' }}
            >
              <Typography variant="label">Assign Role</Typography>
            </Grid>

            <Grid
              item
              md={12}
              sm={12}
              xs={12}
              sx={{
                height: 'calc(90vh - 190px)',
                overflowX: 'hidden',
                marginBottom: '10px',
              }}
            >
              {permissionList?.map((rol, index) => {
                return <>
                  {rol.groupName.includes('Dashboard') ? (
                    ''
                  ) : (
                    <Grid key={rol?.groupName + '_' + index + 'grid'}>
                      <FormControlLabel
                        style={{
                          borderTop: '1px solid silver',
                          width: '100%',
                        }}
                        key={rol?.groupName + '_' + index + 'form'}
                        label={rol?.groupName.replace(
                          /ServiceProvider/g,
                          'Service Provider'
                        )}
                        control={
                          <Checkbox
                            key={rol?.groupName + '_' + index + 'checkbox'}
                            indeterminate={
                              rol.privileges.filter((is) => is.isAssigned)
                                .length != rol.privileges.length &&
                              rol.privileges.filter((is) => is.isAssigned)
                                .length != 0
                            }
                            checked={
                              rol.privileges.filter((is) => is.isAssigned)
                                .length == rol.privileges.length
                            }
                            disabled={rol?.groupName.includes('Company')}
                            onChange={(event) =>
                              handleAllPrivileges(event, rol, index)
                            }
                          />
                        }
                      />
                      <Box
                        key={rol?.groupName + '_' + index + 'box'}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          ml: 3,
                        }}
                      >
                        {rol?.privileges?.map((childRol, index2) => {
                          if (childRol.id == SERVICE_MANAGEMENT_CREATE_SERVICE_ID && commonState.currentCompanyDetails?.companyLevel ==
                            COMPANY_LEVELS.customer && !commonState.currentCompanyDetails.directCustomer) return null //Should not allowed to use create service functionality for ReSeller Customer
                          return (
                            <FormControlLabel
                              key={
                                index +
                                '_' +
                                index2 +
                                '_' +
                                childRol.id +
                                'child'
                              }
                              label={childRol?.displayName?.replace(
                                /ServiceProvider/g,
                                'Service Provider'
                              )}
                              control={
                                <Checkbox
                                  key={
                                    index +
                                    '_' +
                                    index2 +
                                    '_' +
                                    childRol.id +
                                    'checkbox'
                                  }
                                  disabled={childRol?.value.includes(
                                    'company.view'
                                  )}
                                  checked={childRol?.isAssigned}
                                  onChange={(event) =>
                                    handlePrivileges(event, index, index2)
                                  }
                                />
                              }
                            />
                          );
                        })}
                      </Box>
                    </Grid>
                  )}
                </>;
              })}
            </Grid>
          </Grid>
          <Box
            style={{
              position: 'fixed',
              marginTop: '10px',
              background: 'white',
              display: 'flex',
            }}
          >
            <Button
              disabled={!(formik.isValid && formik.dirty)}
              type="submit"
              variant="contained"
              color="primary"
              size="large"
            >
              Add New Role
            </Button>
            <div style={{ marginLeft: '20px' }}>
              <Button
                variant="outlined"
                onClick={() =>
                  props.toggleDrawer('right', false, '', '', false)
                }
                disableElevation
                size="large"
              >
                Cancel
              </Button>
            </div>
          </Box>
        </form>
      </div>
    </Box>
  </>;
}

export default AddNewRole
